import React, { useState, useEffect } from "react";
import { Container, Paper } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { getCharges, getConcepts, getProjects } from "../../services/firestore";
import { Typography } from "@mui/material";

// PCS Admin React components
import MDBox from "components/MDBox";

// PCS Admin React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function Calendar() {
  const [events, setEvents] = useState([]);

  const renderEventContent = (eventInfo) => {
    const charge = eventInfo.event.extendedProps.charge;
    return (
      <MDBox
        sx={{
          p: 1,
          borderRadius: 1,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <Typography 
          variant="subtitle2" 
          fontWeight="bold"
          sx={{ 
            color: "text.primary",
            mb: 0.5,
            fontSize: "0.875rem",
            backgroundColor: "info.light",
            p: 0.5,
            borderRadius: 1,
            textAlign: "center"
          }}
        >
          {charge.proyecto_nombre}
        </Typography>
        <Typography 
          variant="subtitle2" 
          fontWeight="bold"
          sx={{ 
            color: "text.primary",
            mb: 0.5,
            fontSize: "0.875rem"
          }}
        >
          {charge.concepto_nombre}
        </Typography>
        <Typography 
          variant="caption"
          sx={{ 
            color: "text.secondary",
            display: "block",
            mb: 0.5,
            fontSize: "0.75rem"
          }}
        >
          {new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
          }).format(charge.monto)}
        </Typography>
        <Typography 
          variant="caption" 
          sx={{ 
            color: charge.estado === "Pagado" ? "success.main" : "warning.main",
            fontWeight: "bold",
            display: "block",
            fontSize: "0.75rem",
            textTransform: "uppercase"
          }}
        >
          {charge.estado}
        </Typography>
      </MDBox>
    );
  };

  const loadCharges = async () => {
    try {
      const [chargesData, conceptsData, projectsData] = await Promise.all([
        getCharges(),
        getConcepts(),
        getProjects()
      ]);

      const events = chargesData.map((charge) => {
        const concept = conceptsData.find((c) => c.id === charge.concepto_id);
        const project = projectsData.find((p) => p.id === charge.proyecto_id);
        
        return {
          id: charge.id,
          title: concept ? concept.nombre : "Sin concepto",
          start: charge.fecha_vencimiento,
          end: charge.fecha_vencimiento,
          backgroundColor: charge.estado === "Pagado" ? "#4CAF50" : "#FFA726",
          borderColor: charge.estado === "Pagado" ? "#4CAF50" : "#FFA726",
          extendedProps: {
            charge: {
              ...charge,
              concepto_nombre: concept ? concept.nombre : "Sin concepto",
              proyecto_nombre: project ? project.nombre : "Sin proyecto"
            }
          }
        };
      });

      setEvents(events);
    } catch (error) {
      console.error("Error al cargar cobros:", error);
    }
  };

  useEffect(() => {
    loadCharges();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Container maxWidth="lg">
          <Paper 
            sx={{ 
              p: 3, 
              display: "flex", 
              flexDirection: "column",
              borderRadius: 2,
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
            }}
          >
            <FullCalendar
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              events={events}
              locale="es"
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,dayGridWeek",
              }}
              height="auto"
              eventContent={renderEventContent}
              dayMaxEvents={3}
              eventDisplay="block"
              eventTimeFormat={{
                hour: "2-digit",
                minute: "2-digit",
                meridiem: false,
              }}
              eventBorderColor="transparent"
              eventBackgroundColor="transparent"
              eventTextColor="inherit"
              dayHeaderFormat={{ weekday: "long" }}
              buttonText={{
                today: "Hoy",
                month: "Mes",
                week: "Semana"
              }}
              firstDay={1}
              weekends={true}
              nowIndicator={true}
              selectable={true}
              selectMirror={true}
              dayMaxEventRows={true}
              stickyHeaderDates={true}
              allDaySlot={false}
              slotMinTime="00:00:00"
              slotMaxTime="24:00:00"
              expandRows={true}
              height="auto"
              contentHeight="auto"
              aspectRatio={1.35}
            />
          </Paper>
        </Container>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Calendar;
